import { MedicationStatement } from '@medplum/fhirtypes';

// Status options for MedicationStatement
export const STATUS_OPTIONS: MedicationStatement['status'][] = [
  'active',
  'on-hold',
  'stopped',
  'completed',
  'entered-in-error',
];

// Period unit options for timing/frequency
export const PERIOD_UNIT_OPTIONS = [
  { value: 'd', label: 'medications.periodUnits.d' },
  { value: 'wk', label: 'medications.periodUnits.wk' },
  { value: 'mo', label: 'medications.periodUnits.mo' },
] as const;

// Common dose units for medications
export const COMMON_DOSE_UNITS = [
  { value: 'mg', label: 'medications.doseUnits.mg' },
  { value: 'g', label: 'medications.doseUnits.g' },
  { value: 'mcg', label: 'medications.doseUnits.mcg' },
  { value: 'mL', label: 'medications.doseUnits.mL' },
  { value: 'IU', label: 'medications.doseUnits.IU' },
  { value: 'drops', label: 'medications.doseUnits.drops' },
  { value: 'puffs', label: 'medications.doseUnits.puffs' },
  { value: 'tablets', label: 'medications.doseUnits.tablets' },
  { value: 'capsules', label: 'medications.doseUnits.capsules' },
] as const;

// Stop reasons for medications
export const STOP_REASONS = [
  'completed',
  'sideEffects',
  'ineffective',
  'patientRequest',
  'contraindicated',
  'other',
] as const;

// Type-safe translation keys for medications
export type MedicationTranslationKey =
  | 'medications.frequency.onceDaily'
  | 'medications.frequency.twiceDaily'
  | 'medications.frequency.thriceDaily'
  | 'medications.frequency.daily'
  | 'medications.frequency.onceWeekly'
  | 'medications.frequency.weekly'
  | 'medications.frequency.everyTwoWeeks'
  | 'medications.frequency.onceMonthly'
  | 'medications.frequency.monthly'
  | 'medications.frequency.days'
  | 'medications.frequency.weeks'
  | 'medications.frequency.months'
  | 'medications.asNeeded'
  | 'medications.dateRange.since';
